import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { isKnowledgeUser } from './utils';
import { CHAT_MODE } from '../enums/chatMode.enum';
import { chatModeType } from '../types/Chat/Chat.types';

type ResolveComposerModeParams = {
    userInfo?: IAuthMeV2OutputDto;
    currentMode: chatModeType;
    hasFiles: boolean;
};

type ResolveSelectorModeParams = {
    userInfo?: IAuthMeV2OutputDto;
    currentMode: chatModeType;
};

export const resolveComposerMode = ({ userInfo, currentMode, hasFiles }: ResolveComposerModeParams): chatModeType =>
    isKnowledgeUser(userInfo) || hasFiles ? CHAT_MODE.knowledge : currentMode;

export const resolveSelectorMode = ({ userInfo, currentMode }: ResolveSelectorModeParams): chatModeType =>
    isKnowledgeUser(userInfo) ? CHAT_MODE.knowledge : currentMode;
